const SleepQuality = Object.freeze({
    GOOD: "Good",
    SUFFICIENT: "Sufficient",
    POOR: "Poor"
})

export default SleepQuality